'use es6';

import { getAll as getAllProblems } from '../../private/action-problem-solution/actions/edit-dashboard-contents/problem';
import { isEnabled } from '../../private/action-problem-solution/common/is-enabled';
export function canEditDashboardContents(params) {
  return isEnabled(params, getAllProblems);
}